import { render, staticRenderFns } from "./TableRevisionsCell.vue?vue&type=template&id=0dac8fc4&scoped=true"
import script from "./TableRevisionsCell.vue?vue&type=script&lang=js"
export * from "./TableRevisionsCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dac8fc4",
  null
  
)

export default component.exports